<template>
  <div>
    <b-modal
      modal-class="client-form-modal"
      body-class="bg-extra-light-gray p-0"
      footer-class="bg-white border-top-0"
      v-model="showEula"
      :title="''"
      @ok="agreeAndContinue"
      size="md-lg"
      centered
      no-close-on-backdrop
      no-close-on-esc
      header-bg-variant="primary"
      header-text-variant="white"
      header-class="bg-white color-custom-black border-bottom-0"
    >
      <template v-slot:modal-header> <div></div></template>

      <template v-slot:modal-footer> <div></div></template>

      <div class="position-relative">
        <div class="d-flex">
          <div class="client-form-container position-relative w-100 bg-white">
            <div class="section-body" style="padding: 17px 70px !important;">
              <div
                class="w-100 d-flex flex-row justify-content-center align-items-center"
                style="margin-bottom: 35px;"
              >
                <h5 class="modal-title">
                  End User License Agreement
                </h5>
              </div>
              <b-row>
                <b-col>
                  <p v-if="eulaLastUpdated">
                    <strong style="font-size: 13px;"
                      >Last Updated:
                      {{ formatDateOnlyPretty(eulaLastUpdated) }}</strong
                    >
                  </p>
                  <div class="position-relative">
                    <div style="max-height: 371px; overflow-y: scroll;">
                      <div
                        id="eulaBody"
                        ref="eulaBody"
                        class="eula-body color-custom-black"
                        v-html-sanitize="eulaBody"
                      ></div>
                      <div class="fadeout"></div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center w-100"
                    style="font-size: 13px; margin-top: 15px;"
                  >
                    <div class="text-left mt-1 mr-2">
                      <b-form-checkbox
                        id="accepted-checkbox"
                        v-model="accepted"
                        name="accepted-checkbox"
                        value="accepted"
                        unchecked-value="not_accepted"
                      >
                        <div style="margin-top:3px">
                          I have read and agree to this End User License
                          Agreement, the
                          <a
                            href="https://www.opusbehavioral.com/links/terms-conditions"
                            target="_blank"
                          >
                            Software License Terms & Conditions</a
                          >
                          and
                          <a
                            href="https://www.opusbehavioral.com/links/cookies-policy"
                            target="_blank"
                          >
                            Cookie Policy</a
                          >
                        </div>
                      </b-form-checkbox>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-center align-items-center w-100"
                    style="margin: 26px 0px;"
                  >
                    <b-button
                      class="ml-2"
                      variant="outline-danger"
                      @click="logout"
                      style="width:120px;"
                      >Decline</b-button
                    >
                    <b-button
                      v-if="showEula"
                      class="ml-2"
                      variant="success"
                      @click="agreeAndContinue"
                      :disabled="accepted == 'not_accepted'"
                      style="width:120px;"
                      >Accept</b-button
                    >
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <my-account-modal v-if="showAccountModal" v-model="showAccountModal" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import userServer from "../../server/user";
import moment from "moment";
import { setToken } from "../../helpers/session";
import { formatDateOnlyPretty } from "../../helpers/date";
import MyAccountModal from "./MyAccountModal";

export default {
  name: "Eula",
  components: { MyAccountModal },
  data() {
    return {
      scrolledToEnd: false,
      showEula: true,
      showAccountModal: false,
      eulaBody: null,
      eulaLastUpdated: null,
      accepted: "not_accepted"
    };
  },
  async mounted() {
    await this.fetchSystemSetting();
    const today = moment(new Date()).format("MMMM DD, yyyy");
    this.eulaBody = this.systemSetting.eulaBody?.replace("{{today}}", today);
    this.eulaLastUpdated = this.systemSetting.eulaLastUpdated;
  },
  updated() {
    const self = this;
    this.$nextTick(() => {
      const eulaBodyElement = self.$refs.eulaBody;
      if (!eulaBodyElement) return;
      if (
        eulaBodyElement.clientHeight < 350 &&
        eulaBodyElement.clientHeight > 0
      ) {
        this.scrolledToEnd = true;
      } else {
        eulaBodyElement.addEventListener("scroll", () => {
          if (
            eulaBodyElement.offsetHeight + eulaBodyElement.scrollTop >=
            eulaBodyElement.scrollHeight
          ) {
            this.scrolledToEnd = true;
          }
        });
      }
    });
  },
  methods: {
    ...mapActions("layout", [
      "showAlertSuccess",
      "fetchCurrentUser",
      "fetchSystemSetting"
    ]),
    agreeAndContinue() {
      userServer.agreeToEULA(this.currentUser.id).then(res => {
        if (res) {
          this.showAlertSuccess();
          this.showEula = false;
          let user = this.currentUser;
          if (
            !user.firstName ||
            !user.lastName ||
            !user.email ||
            !user.signature
          ) {
            this.showAccountModal = true;
          }
        }
      });
    },
    logout() {
      setToken("");
      location.reload();
    },
    formatDateOnlyPretty(date) {
      return formatDateOnlyPretty(date);
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      systemSetting: state => state.systemSetting
    })
  }
};
</script>

<style scoped>
.section-body {
  min-height: 100px;
  height: 613px;
}
.eula-body {
  padding-right: 15px;
}
div.fadeout {
  height: 73px;
  width: 100%;
  position: sticky;
  bottom: -1px;
  right: 10px;
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 90%
  );
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, rgba(255, 255, 255, 0)),
    color-stop(95%, rgba(255, 255, 255, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 90%
  );
  background: -o-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 90%
  );
  background: -ms-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 90%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 90%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 );
}
</style>
<style>
.eula-body p {
  text-align: justify !important;
  text-justify: auto;
}
</style>
